export default __webpack_public_path__ + "static/media/allstate-logo.32c3bc85.png";